import { render, staticRenderFns } from "./UploadAttachmentModal.vue?vue&type=template&id=75401634&scoped=true"
import script from "./UploadAttachmentModal.vue?vue&type=script&lang=js"
export * from "./UploadAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75401634",
  null
  
)

export default component.exports